const gallery = {
  btns: document.querySelectorAll('.jsLoadGallery') as NodeListOf<HTMLElement>,
  ele: document.getElementById('jsVideoPlayer') as HTMLElement,

  init() {
    this.setVideo();
  },

  setVideo() {
    document.addEventListener('DOMContentLoaded', () => {
      this.btns.forEach((btn) => {
        btn.addEventListener('click', () => {
          const videoId: string | null = btn.getAttribute('data-video-id');

          if (videoId) {
            this.ele.innerHTML = `<img src='${videoId}' alt='${videoId}' />`;
          }
        });
      });
    });
  },
};

export default gallery;
